import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check } from 'lucide-react';
import { PRODUCT_NAME } from './Shared';
const buyers = [{
  name: 'Chiara M.',
  location: 'Bologna'
}, {
  name: 'Luca R.',
  location: 'Torino'
}, {
  name: 'Giulia F.',
  location: 'Firenze'
}, {
  name: 'Marco P.',
  location: 'Padova'
}, {
  name: 'Elena S.',
  location: 'Milano'
}, {
  name: 'Davide T.',
  location: 'Roma'
}];
export const FloatingNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: 'Chiara M.',
    location: 'Bologna',
    time: '9 minuti fa'
  });
  useEffect(() => {
    const initialTimer = setTimeout(() => setIsVisible(true), 15000);
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
        setNotificationData({
          ...randomBuyer,
          time: `${Math.floor(Math.random() * 59) + 1} minuti fa`
        });
        setIsVisible(true);
      }, 1000);
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-81" data-mp="1r00if85ekwov">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      type: 'spring',
      stiffness: 340,
      damping: 28
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-xs" role="status" aria-live="polite" data-id="element-82" data-mp="1mwvkliw9pj6k">
          <div className="glass-panel p-4 rounded-sm flex items-start gap-3" data-id="element-83" data-mp="187plrw1cduz7">
            <div className="border border-brand-gold/50 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-84" data-mp="139o2pb3x1vnq">
              <Check className="w-3.5 h-3.5 text-brand-goldDark" data-id="element-85" data-mp="z5gd7bpmwbog" />
            </div>
            <div data-id="element-86" data-mp="u7ew2wbrqmfm">
              <p className="font-seal text-[9px] uppercase tracking-seal text-brand-muted mb-1.5" data-id="element-87" data-mp="u8znwe6p7r9s">
                Acquisto verificato · {notificationData.time}
              </p>
              <p className="text-sm text-brand-text" data-id="element-88" data-mp="olwg7cfgq06p">
                <span className="font-semibold text-brand-purpleDark" data-id="element-89" data-mp="ojbcehvlta6b">
                  {notificationData.name}
                </span>{' '}
                da {notificationData.location} ha acquistato
              </p>
              <p className="text-sm text-brand-goldDark font-medium" data-id="element-90" data-mp="13asmb3xyl34o">
                {PRODUCT_NAME}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};